/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_Fact1Inputs */

const en_dr_room_fact1 = /** @type {(inputs: Dr_Room_Fact1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virtual brainwriting beats video brainstorming — more ideas, more original, deeper elaboration (Baruah et al. 2025).`)
};

const id_dr_room_fact1 = /** @type {(inputs: Dr_Room_Fact1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brainwriting virtual mengalahkan brainstorming video — lebih banyak ide, lebih orisinal, elaborasi lebih dalam (Baruah dkk. 2025).`)
};

/**
* | output |
* | --- |
* | "Virtual brainwriting beats video brainstorming — more ideas, more original, deeper elaboration (Baruah et al. 2025)." |
*
* @param {Dr_Room_Fact1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_fact1 = /** @type {((inputs?: Dr_Room_Fact1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_Fact1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_fact1(inputs)
	return en_dr_room_fact1(inputs)
});